export default "__VITE_ASSET__D$Cbe8B0__"